var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LanguageSwitcher } from '../LanguageSwitcher';
import styles from './jotpa.module.css';
export function Header(_a) {
    var title = _a.title;
    return (_jsxs("header", { children: [_jsxs("div", __assign({ className: "header" }, { children: [_jsx("div", { children: _jsx("img", { className: styles.jotpaLogo, src: "/jotpa_logo.png", alt: "" }) }), _jsx(LanguageSwitcher, {})] })), _jsx("div", __assign({ className: "content" }, { children: _jsx("h1", { children: title }) }))] }));
}
